import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { message, Table, Typography } from "antd";
import { api } from "../../api/api";
import { IAuditAction } from "../../types/auditActions.type";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title } = Typography;
export default function AuditActionsStats() {
  const { startDate, endDate } = useParams();
  const [actions, setActions] = useState<IAuditAction[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchActions = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/stats/audit-actions`, {
        params: {
          startDate,
          endDate,
        },
      });

      setActions(response.data);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение данных.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActions();
  }, [startDate, endDate]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Тип ревизии",
      dataIndex: "auditType",
      key: "auditType",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
      render: (amount: number) => roundToThreeDecimals(amount),
    },
    {
      title: "Общ.Прибыль до",
      dataIndex: "netProfitBefore",
      key: "netProfitBefore",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Общ.Прибыль после",
      dataIndex: "netProfitAfter",
      key: "netProfitAfter",
      render: (data: number) => roundToThreeDecimals(data),
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>
        Ревизия {startDate} - {endDate}
      </Title>

      <Table
        loading={loading}
        columns={columns}
        dataSource={actions}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
